import React from 'react'
import SubnavBar from 'Components/Shared/SubnavBar'
import { BreadcrumbLink } from 'Components/Shared/BreadCrumb/BreadCrumb'

type Props = {
  name?: string
  type?: string
}

const Breadcrumbs: React.ComponentType<Props> = props => {
  const { name, type = 'unit' } = props
  const breadcrumbs: BreadcrumbLink[] = [
    {
      url: `/${type}/dashboard`,
      title: 'Home',
      icon: '/home.png',
      active: true,
      showTitle: false,
    },
    {
      url: `/${type}/dashboard`,
      title: 'บอร์ด',
      active: true,
      showTitle: true,
    },
    {
      url: ``,
      title: 'โครงการขอตรวจ',
      active: false,
      showTitle: true,
    },
  ]

  return <SubnavBar breadcrumbs={breadcrumbs} hideSearch={true} />
}

export default Breadcrumbs
